import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'layout',
  //   component: () => import('../pages/layout/index.vue'),
  //   redirect: '/carmine',
  //   children: [
  //     {
  //       path: '/carmine',
  //       name: 'carmine',
  //       component: () => import('../pages/carmine/index.vue'),
  //       meta: {
  //         title: '仪表盘'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login.vue')
  },
  {
    path: '/myPlatform',
    name: 'myPlatform',
    redirect: '/myPlatform/index',
    component: () => import('../pages/myPlatform/index.vue'),
    children: [{
      path: 'index',
      name: 'myPlatformIndex',
      component: () => import('../pages/myPlatform/platform.vue')
    }]
  },
  {
    path: '/shop',
    component: () => import('../pages/shop/ShopLayout.vue'),
    children: [
      { path: '', name: 'shopProducts', component: () => import('../pages/shop/products.vue') },
      { path: 'login', name: 'shopLogin', component: () => import('../pages/shop/login.vue') },
      { path: 'change-password', name: 'shopChangePwd', component: () => import('../pages/shop/changePassword.vue') },
      { path: 'product/:id', name: 'shopProductDetail', component: () => import('../pages/shop/productDetail.vue') },
      { path: 'exchange/:id', name: 'shopExchange', component: () => import('../pages/shop/exchange.vue') },
      { path: 'orders', name: 'shopOrders', component: () => import('../pages/shop/orders.vue') },
      { path: 'me', name: 'shopMe', component: () => import('../pages/shop/me.vue') }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/yxsj_crm/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 商城（观众/商城用户）路由：使用独立的 audience token，与后台 admin token 隔离
  if (typeof to.path === 'string' && to.path.startsWith('/shop')) {
    if (to.name === 'shopLogin') { next(); return }
    if (!localStorage.getItem('audience_token')) { next({ name: 'shopLogin' }); return }
    if (localStorage.getItem('audience_must_reset') === '1' && to.name !== 'shopChangePwd') {
      next({ name: 'shopChangePwd' }); return
    }
    next(); return
  }

  const hasToken = Boolean(localStorage.getItem('token'))

  if (['myPlatform', 'myPlatformIndex'].includes(to.name as string) && !hasToken) {
    next({ name: 'login' })
    return
  }

  if (to.name === 'login' && hasToken) {
    next({ name: 'myPlatform' })
    return
  }

  next()
})

export default router
